var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{class:{ 'grey--text text--darken-1': ! _vm.active },attrs:{"cols":"12"}},[_c('v-icon',{attrs:{"left":"","small":"","color":_vm.active ? 'grey darken-3' : 'grey'},domProps:{"textContent":_vm._s(_vm.icons[_vm.icon])}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }